import { useEffect } from 'react';
import { useOnboardingStore } from '../store/onboardingStore';
import { useAuthStore } from '../store/authStore';

export const useOnboarding = () => {
  const {
    isCompleted,
    currentStep,
    isTourRunning,
    loadStatus,
    updateStep,
    markComplete,
  } = useOnboardingStore();
  const { user } = useAuthStore();

  // Load onboarding status on mount
  useEffect(() => {
    loadStatus();
  }, [loadStatus]);

  // Determine if should show tour
  const shouldShowTour = !isCompleted && user && !isTourRunning;

  return {
    shouldShowTour,
    currentStep,
    isTourRunning,
    updateStep,
    markComplete,
  };
};
